<template lang='pug'>
el-card

  div(slot='header')
    i.mat-icon vpn_key
    | Change password

  el-row(:gutter='$rowGutter', style='font-size: 0.9rem; color: #888; margin-bottom: 1rem')

    el-col(:span='24')
      | If you want to change your login password click below to receive reset link to your account's e-mail address. Go to your inbox your inbox and visit the link to set a new password.

  el-row(:gutter='$rowGutter')

    el-col(:span='24')
      el-button(
        type="primary", icon="el-icon-add", @click="onPasswordReset",
        :loading='loading'
      )
        | Send to my e-mail a password reset link
</template>

<script>
  import Vue from 'vue'
  import auth from '../../auth.js'

  function onPasswordReset(){
    this.loading = true
    auth.changePassword().then(()=>{
      this.loading = false
      this.$message("Reset link sent. Please check your inbox")
    }).catch((e)=>{
      console.log("Failed to reset password",e)
      this.loading = false
      this.$message.error("Failed to request the reset link")
    })
  }

  const methods = {
    onPasswordReset
  }

  const props = {
    labelWidth: { default: Vue.$labelWidth },
    size: { default: Vue.$defaultFormSize },
    labelPosition: { default: Vue.$defaultlabelPosition },
    displaySave: {default: false}
  }

  function data(){
    return {
      loading: false
    }
  }

  export default { props, data, methods }
</script>



// WEBPACK FOOTER //
// src/user/blocks/PasswordChanger.vue